import {SourcingVehicleResponseBody} from '@dms/api/core';

import {CARVAGO_BUY_BLOCKED_SUSPICIOUS_REASONS} from '../constants/sourcingSuspiciousReasons';

export function isCarvagoBuyBlockedBySuspiciousVehicle(
  sourcingVehicle: Pick<SourcingVehicleResponseBody, 'suspicious' | 'suspiciousReason'>
): boolean {
  if (!sourcingVehicle.suspicious) {
    return false;
  }

  return sourcingVehicle.suspiciousReason.some((reason) =>
    CARVAGO_BUY_BLOCKED_SUSPICIOUS_REASONS.includes(reason)
  );
}
